
import React from 'react';
import { Category } from '@/types/assessment';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface CategorySelectorProps {
  categories: Category[];
  selectedCategoryId: string;
  setSelectedCategoryId: (id: string) => void;
}

export function CategorySelector({ 
  categories, 
  selectedCategoryId, 
  setSelectedCategoryId 
}: CategorySelectorProps) {
  return (
    <div className="w-full">
      <label htmlFor="category-selector" className="block text-sm font-medium mb-2">
        Select Category
      </label>
      <Select 
        value={selectedCategoryId} 
        onValueChange={setSelectedCategoryId}
      >
        <SelectTrigger className="w-full">
          <SelectValue placeholder="Select a category" />
        </SelectTrigger>
        <SelectContent>
          {categories.map(category => (
            <SelectItem key={category.id} value={category.id}>
              {category.name || 'Unnamed Category'}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
